import * as React from "react";
import {
    Toolbar,
    Button,
    ButtonGroup,
} from "@progress/kendo-react-buttons";

import { Grid, GridColumn as Column, GridCellProps } from '@progress/kendo-react-grid';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import TobaccoNew from "./OHTobaccoNew";

import { useGetTobaccoQuery } from '../store/sunbright-api';
import { useDeleteTobaccoMutation } from '../store/sunbright-api';

const consentWithCheck = (props: GridCellProps) => {
    return (
        <td style={{color:"green"}} data-grid-col-index={6}>
            {props.dataItem.consent ? <span className="k-icon k-font-icon k-i-check" /> : null}
        </td>
    );
};
const referralWithCheck = (props: GridCellProps) => {
    return (
        <td style={{ color: "green" }} data-grid-col-index={12}>
            {props.dataItem.omscreferral ? <span className="k-icon k-font-icon k-i-check" /> : null}
        </td>
    );
};

export interface OHTobaccoProps {
    eventID: number;
    regionID: number;
    onReturn?: any;
}
interface TobaccoRow {
    uid: number;
    regionid?: number;
    eventid?: number;
    row?: number;
    name?: string;
    phone?: string;
    email?: string;
    gender?: string;
    age?: number;
    consent?: boolean;
    yearssmoked?: number;
    cigsperday?: string;
    patches?: string;
    gum?: string;
    lozenges?: string;
    omcsreferral?: boolean;
    vouchernumber?: string;
    examid?: string;
}

const DATA_ITEM_KEY = 'uid';

const OHTobacco = ({
    eventID,
    regionID,
    onReturn,
}: OHTobaccoProps) => {

    const ActionCell = (props: any) => {
        const { dataItem } = props;

        return (
            <td className="k-command-cell">
                <Button
                    icon="edit"
                    style={{ background: "center" }}
                    onClick={(e) => editClicked(dataItem)}
                >
                </Button>
                <Button
                    icon="trash"
                    style={{ background: "center" }}
                    onClick={(e) => deleteClicked(dataItem)}
                >
                </Button>
            </td>
        );
    };

    const { data: tobacco, error: tobaccoError, isLoading: tobaccoLoading } = useGetTobaccoQuery(eventID + "");
    const [tobaccoData, setTobaccoData] = React.useState<any>(null);

    const [deleteTobacco, deleteResponse] = useDeleteTobaccoMutation();

    const [newTobacco, setNewTobacco] = React.useState<boolean>(false);
    const [editTobacco, setEditTobacco] = React.useState<boolean>(false);
    const [selectedItem, setSelectedItem] = React.useState<any>({});
    const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
    const [gridHeight, setGridHeight] = React.useState<string>("600px");
    const [tobaccoHeader, setTobaccoHeader] = React.useState<string>("Tobacco Tracking Sheet");

    React.useEffect(() => {
        window.addEventListener("resize", handleResize);
        setGridHeight((window.innerHeight - 150) + "px");
    }, []);

    const handleResize = () => {
        setGridHeight((window.innerHeight - 100) + "px");
    };

    React.useEffect(() => {
        if (tobacco) {
            setTobaccoData(tobacco);
       }
    }, [tobacco]);

    const editClicked = (dataItem: any) => {
        setSelectedItem(dataItem);
        setEditTobacco(true);
    };

    const deleteClicked = (dataItem: any) => {
        setSelectedItem(dataItem);
        setConfirmDelete(true);
    };

    const deleteConfirmed = (dataItem: any) => {
        deleteTobacco(dataItem)
            .unwrap()
            .then((payload) => { })
            .catch((error) => {
                console.log(error)
            });

        setConfirmDelete(false);
    };

    return (
        <React.Fragment>
            {(editTobacco) ?
                (<div>
                    <TobaccoNew
                        onReturn={(submitted: boolean) => setEditTobacco(false)}
                        uid={selectedItem.uid}
                        regionid={regionID}
                        eventid={eventID}
                        row={-1}
                        editValues={selectedItem}
                    />
                </div>)
                :
                ((newTobacco) ?
                    (<div>
                        <TobaccoNew
                            onReturn={(submitted: boolean) => setNewTobacco(false)}
                            uid={-1}
                            regionid={regionID}
                            eventid={eventID}
                            row={tobaccoData.length + 1}
                            editValues={{}}
                        />
                    </div>) :
                    (<div>
                        <Toolbar>
                            <ButtonGroup>
                                <Button
                                    className="sds-buttoninbar"
                                    icon="undo"
                                    onClick={(e) => onReturn()}
                                >
                                    Return to Tobacco
                                </Button>
                            </ButtonGroup>
                            <div style={{ fontSize: "large", fontWeight: "bold", paddingLeft: "64px" }}>
                                {tobaccoHeader}
                            </div>
                        </Toolbar>
                        <div>
                            {(confirmDelete) &&
                                <Dialog title={<div><span className="k-icon k-font-icon k-i-info" style={{ color: "green" }} ></span>&nbsp;Please confirm</div>}
                                    onClose={(e) => setConfirmDelete(false)}>
                                    <p style={{ margin: "25px", textAlign: "center" }}>
                                        Are you sure you want to delete <br />'{selectedItem.name}' ?
                                    </p>
                                    <DialogActionsBar>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            onClick={(e) => deleteConfirmed(selectedItem)}
                                        >
                                            Yes
                                        </button>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                            onClick={(e) => setConfirmDelete(false)}
                                        >
                                            No
                                        </button>
                                    </DialogActionsBar>
                                </Dialog>
                            }
                        </div>
                       <Button
                            themeColor={"primary"}
                            icon="plus-circle"
                            onClick={() => setNewTobacco(true)}
                            style={{ position: "absolute", top: "46px", right: "64px", width: "128px", zIndex: "99" }}>
                            New Client
                        </Button>
                        <Grid
                            style={{ height: gridHeight }}
                            className="tobaccoGrid"
                            dataItemKey={DATA_ITEM_KEY}
                            pageable={false}
                            data={tobaccoData}
                            resizable={true}
                        >
                            <Column field="uid" filter="numeric" title=" " width="0px" />
                            <Column cells={{ data: (props) => <ActionCell {...props} /> }} width="100px" />
                            <Column field="name" title="Name" width="163px" />
                            <Column field="phone" title="Phone #" width="110px" />
                            <Column field="email" title="Email" width="100px" />
                            <Column field="gender" title="Gender" width="71px" />
                            <Column field="age" title="Age (years)" width="70px" />
                            <Column field="consent" title="Verbal Consent" width="75px" cell={consentWithCheck} />
                            <Column field="yearssmoked" title="# Years Smoked" width="77px" />
                            <Column field="cigsperday" title="# Cigs /Day" width="60px" />
                            <Column field="patches" title="Patches" width="182px" />
                            <Column field="gum" title="Gum" width="78px" />
                            <Column field="lozenges" title="Lozenges" width="78px" />
                            <Column field="omscreferral" title="OMSC Referral" width="71px" cell={referralWithCheck} />
                            <Column field="vouchernumber" title="Voucher Number" width="79px" />
                            <Column field="examid" title="Exam ID" width="66px" />
                        </Grid>
                    </div>)
                )}
    </React.Fragment>
    );
};
export default OHTobacco;
